export default "__VITE_ASSET__GyM_XJ4g__"